import React from "react";
import Label from "../Common/Label";
import "./ImageAndContentIns.css";

const X_image: React.FC = () => {
  return (
    <div className="container mt-3">
      <div className="row">
        <div className="col-md-6">
          <div className="header-label">
            <Label children="Best Practices" fontWeight={600} fontSize="20px" />
          </div>
          <div className="list-items mt-2">
            <ul className="custom-list">
              <li>
                <Label
                  children="Use high-resolution images (blurry or pixelated images reduce engagement)."
                  fontSize="14px"
                  fontWeight={400}
                />
              </li>
              <li>
                <Label
                  children="Keep text overlays minimal (focus on visuals, as text in images is not searchable)."
                  fontSize="14px"
                  fontWeight={400}
                />
              </li>
              <li>
                <Label
                  children="Ensure key content is centered to avoid cropping on different devices."
                  fontSize="14px"
                  fontWeight={400}
                />
              </li>
              <li>
                <Label
                  children="Write a concise and engaging caption (keep it within 125-150 characters for best results)."
                  fontSize="14px"
                  fontWeight={400}
                />
              </li>
              <li>
                <Label
                  children="Use a strong CTA (e.g., 'Apply Now,' 'Learn More,' 'Join Us')."
                  fontSize="14px"
                  fontWeight={400}
                />
              </li>
              <li>
                <Label
                  children="Tag relevant people or brands to boost reach (@username)."
                  fontSize="14px"
                  fontWeight={400}
                />
              </li>
              <li>
                <Label
                  children="Post at optimal times (mid-morning and early evening tend to perform best)."
                  fontSize="14px"
                  fontWeight={400}
                />
              </li>
            </ul>
          </div>
        </div>
        <div className="col-md-6">
          <div className="header-label">
            <Label children="Restrictions " fontWeight={600} fontSize="20px" />
          </div>
          <div className="list-items mt-2">
            <div>
              <Label
                children="Image Restrictions:"
                fontWeight={400}
                fontSize="14px"
              />
              <ul>
                <li>
                  <Label
                    children="Formats: JPG, PNG"
                    fontWeight={400}
                    fontSize="14px"
                  />
                </li>

                <li>
                  <Label
                    children="Max File Size: 5MB"
                    fontWeight={400}
                    fontSize="14px"
                  />
                </li>
              </ul>
            </div>
            <div>
              <Label
                children="Text Restrictions:"
                fontWeight={400}
                fontSize="14px"
              />
              <ul>
                <li>
                  <Label
                    children="Caption Limit: 280 characters"
                    fontWeight={400}
                    fontSize="14px"
                  />
                </li>

                <li>
                  <Label
                    children="Hashtags: No limit, but best practice is 1-3 relevant hashtags."
                    fontWeight={400}
                    fontSize="14px"
                  />
                </li>

                <li>
                  <Label
                    children="Mentions (@username): Allowed and effective for engagement."
                    fontWeight={400}
                    fontSize="14px"
                  />
                </li>

                <li>
                  <Label
                    children="Emojis: Allowed but should be used sparingly for readability."
                    fontWeight={400}
                    fontSize="14px"
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default X_image;
